'use client';

import { Paper, SimpleGrid, Stack, Text, ThemeIcon, Title } from '@mantine/core';

// Маркетинговые feature-карточки landing-страницы (as-is-перенос эталона;
// FE-05: ранее лежали в `lib/mock-data.ts` — имя вводило в заблуждение).
const FEATURES = [
  {
    icon: '📰',
    title: 'Новости и объявления',
    description:
      'Актуальная лента корпоративных новостей, важные объявления и обновления законодательства.',
  },
  {
    icon: '🎓',
    title: 'Обучение и развитие',
    description:
      'Мероприятия, курсы, вебинары и обучающие материалы для профессионального роста.',
  },
  {
    icon: '📋',
    title: 'Управление документами',
    description:
      'Удобные инструменты для работы с документами, их хранения и совместного использования.',
  },
  {
    icon: '💬',
    title: 'Чат и поддержка',
    description:
      'Онлайн-чат для клиентов, система тикетов и история обращений в службу поддержки.',
  },
] as const;

export default function Features() {
  return (
    <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg" mt="xl" w="100%">
      {FEATURES.map((feature) => (
        <Paper key={feature.title} p="xl" h="100%">
          <Stack gap="sm" align="center">
            <ThemeIcon size="xl" radius="md" variant="light" color="violet">
              <Text fz="xl">{feature.icon}</Text>
            </ThemeIcon>

            <Title order={3} size="h4" ta="center">
              {feature.title}
            </Title>

            <Text size="sm" c="dimmed" lh={1.7} ta="center">
              {feature.description}
            </Text>
          </Stack>
        </Paper>
      ))}
    </SimpleGrid>
  );
}
